import * as React from 'react'

import {Flex} from '@ua/design-system/components/flex'
import {Input} from '@ua/design-system/components/input'
import {Link} from '@ua/design-system/components/link'

interface Props {
  name: string
  value: string | undefined
  onChange: (arg: string) => void
  helperLink?: string
}

const AdditionalTextInput: React.FC<Props> = ({
  name,
  value,
  onChange,
  helperLink,
}) => {
  return (
    <>
      <Input
        label={name}
        value={value}
        onChange={(e) => onChange(e.currentTarget.value)}
      />
      {helperLink && (
        <Flex direction="row-reverse">
          <Link href={helperLink} target="blank">
            What is this?
          </Link>
        </Flex>
      )}
    </>
  )
}

export default AdditionalTextInput
